import { useEffect, useState } from "react";

import { Box, Grid } from "@mui/material";
import { Button, TextFieldHookForm, Typography } from "components";
import PhoneFieldHookForm from "components/PhoneField/PhoneField.hookform";
import { useFormContext } from "react-hook-form";

interface Props {
  isValidatedPhoneNumber: boolean;
  handleSubmitForm: (
    smsOtp: string,
    phoneNumber: string,
    base64: string
  ) => void;
  handleSubmitRequestOtp: (input: string) => void;
}

export const AuthSignOTP = (props: Props) => {
  const { isValidatedPhoneNumber, handleSubmitForm, handleSubmitRequestOtp } =
    props;
  const { watch, trigger } = useFormContext();
  const [activeStep, setActiveStep] = useState<number>(1);

  useEffect(() => {
    if (isValidatedPhoneNumber) {
      setActiveStep(2);
    }
  }, [isValidatedPhoneNumber, setActiveStep]);

  return (
    <>
      {activeStep === 1 && (
        <>
          <Typography type="TextLG" fontWeight={600}>
            Vui lòng cung cấp số điện thoại
          </Typography>
          <Grid container spacing="14px" marginTop="0">
            <Grid item xs={12} lg={6}>
              <PhoneFieldHookForm
                required
                name="phoneNumber"
                label="Phone number"
                placeholder="Enter phone number"
              />
            </Grid>
          </Grid>
          <Box display="flex" justifyContent="end" marginTop={8}>
            <Box>
              <Button
                onClick={async () => {
                  if (await trigger("phoneNumber")) {
                    handleSubmitRequestOtp(
                      `${
                        JSON.parse(watch("phoneNumber") as string)
                          ?.countryCallingCode as string
                      }${
                        JSON.parse(watch("phoneNumber") as string)
                          ?.nationalNumber as string
                      }`
                    );
                  }
                }}
              >
                Gửi OTP
              </Button>
            </Box>
          </Box>
        </>
      )}
      {activeStep === 2 && (
        <>
          <Typography type="TextLG" fontWeight={600}>
            Vui Lòng cung cấp mã OTP
          </Typography>
          <Grid container spacing="14px" marginTop="0">
            <Grid item xs={12} lg={6}>
              <TextFieldHookForm
                required
                name="otp"
                label="Mã OTP"
                placeholder="Enter OTP number"
                type="number"
              />
            </Grid>
          </Grid>
          <Box display="flex" justifyContent="end" marginTop={8}>
            <Box>
              <Button
                onClick={
                  // eslint-disable-next-line
                  async () => {
                    if (await trigger("otp")) {
                      handleSubmitForm(
                        watch("otp") as string,
                        `${
                          JSON.parse(watch("phoneNumber") as string)
                            ?.countryCallingCode as string
                        }${
                          JSON.parse(watch("phoneNumber") as string)
                            ?.nationalNumber as string
                        }`,
                        watch("imgBase64") as string
                      );
                    }
                  }
                }
              >
                Xác thực
              </Button>
            </Box>
          </Box>
        </>
      )}
    </>
  );
};
